import * as React from "react";
import { FooterContact, FooterCopyright, Paragraph } from "scuid-x";
import "./Footer.css";

export const Footer: React.SFC = () => (
  <FooterCopyright>
    <FooterContact>
      <div className={"footerComponent-paragraph"}>
        <Paragraph>
          For important disclosures and other information,
          visit <a href="https://www.sofi.com/legal/">SoFi.com/legal.</a> SoFi Lending Corp. is licensed by the
          Department of Business Oversight under the California Financing law, license number 6054612. Terms and
          conditions apply; see <a href="https://www.sofi.com/eligibility-criteria/">SoFi.com/eligibility</a> for
          details. NMLS # 1121636.
        </Paragraph>
      </div>
    </FooterContact>
  </FooterCopyright>
);



// WEBPACK FOOTER //
// ./src/components/Footer.tsx